export class ReimbursementCosts {
    fullReimbursement?: boolean;
    travelAllowanceAmount?: number;
    foregoDailyAllowance?: boolean;
    foregoAccommodationAllowance?: boolean;
    foregoTravelCosts?: boolean;
    foregoParticipationFees?: boolean;
    accidentCare?: boolean;
    provideCompensationAmount?: boolean;
}
